/**
 * "Última movimentação" do card em linguagem de gente: "há 3 dias", "ontem", "há 2 horas".
 * Só formata a data que o backend mandou (`ultimaMovimentacaoEm`) — não decide nada.
 * `agora` é injetável para o teste não depender do relógio.
 */
const rtf = new Intl.RelativeTimeFormat('pt-BR', { numeric: 'auto' })

const MINUTO = 60
const HORA = 60 * MINUTO
const DIA = 24 * HORA

export const tempoRelativo = (
  iso: string | null | undefined,
  agora: Date = new Date(),
): string | null => {
  if (!iso) return null
  const instante = new Date(iso).getTime()
  if (Number.isNaN(instante)) return null

  const segundos = Math.round((instante - agora.getTime()) / 1000)
  const abs = Math.abs(segundos)
  if (abs < MINUTO) return 'agora'
  if (abs < HORA) return rtf.format(Math.trunc(segundos / MINUTO), 'minute')
  if (abs < DIA) return rtf.format(Math.trunc(segundos / HORA), 'hour')
  const dias = Math.trunc(segundos / DIA)
  if (Math.abs(dias) < 30) return rtf.format(dias, 'day')
  if (Math.abs(dias) < 365) return rtf.format(Math.trunc(dias / 30), 'month')
  return rtf.format(Math.trunc(dias / 365), 'year')
}
